<template>
    <div id="apiDocument">
        <!--接口地址-->
        <div class="addressWrap">
            <div class="address">
                <div><span>接口地址：</span>http://apis.juhe.cn/telecomCucc_md5/query</div>
                <div><span>返回格式：</span>json</div>
                <div><span>请求方式：</span>get/post</div>
                <div><span>请求示例：</span>http://apis.juhe.cn/telecomCucc_md5/query?idcard=&realname=&mobile=&key=</div>
                <div style="margin-bottom: 32px"><span>接口备注：</span>三要素MD5大写分别加密后传输,其中姓名需要先GBK编码后再MD5上传</div>
                <button @click="apiBtnEvent">api测试工具</button>
            </div>
        </div>
        <!--请求参数说明-->
        <div class="requestWrap">
            <div class="parameter">
                <div class="requestTitle">请求参数说明：</div>
                <!--列子-->
                <div class="requestCodeWrap">
                    <div class="requestCodeList">
                        <span class="name">名称</span>
                        <span class="required">必填</span>
                        <span class="type">类型</span>
                        <span class="explain">说明</span>
                    </div>
                    <div class="requestCodeList">
                        <span class="name">Key</span>
                        <span class="required">是</span>
                        <span class="type">string</span>
                        <span class="explain">在个人中心->我的数据,接口名称上方查看</span>
                    </div>
                    <div class="requestCodeList">
                        <span class="name">realname</span>
                        <span class="required">是</span>
                        <span class="type">string</span>
                        <span class="explain">姓名需先用GBK编码后再MD5加密转大写</span>
                    </div>
                    <div class="requestCodeList">
                        <span class="name">idcard</span>
                        <span class="required">是</span>
                        <span class="type">string</span>
                        <span class="explain">身份证号码MD5大写</span>
                    </div>
                    <div class="requestCodeList">
                        <span class="name">mobile</span>
                        <span class="required">是</span>
                        <span class="type">string</span>
                        <span class="explain">身份证号码MD5大写</span>
                    </div>
                </div>
            </div>
        </div>
        <!--返回参数说明：-->
        <div class="responseWrap">
            <div class="parameter">
                <div class="requestTitle">返回参数说明：</div>
                <!--列子-->
                <div class="requestCodeWrap">
                    <div class="requestCodeList">
                        <span class="name">名称</span>
                        <span class="required"></span>
                        <span class="type">类型</span>
                        <span class="explain">说明</span>
                    </div>
                    <div class="requestCodeList">
                        <span class="name">error_code</span>
                        <span class="required"></span>
                        <span class="type">string</span>
                        <span class="explain">在个人中心->我的数据,接口名称上方查看</span>
                    </div>
                    <div class="requestCodeList">
                        <span class="name">reason</span>
                        <span class="required"></span>
                        <span class="type">string</span>
                        <span class="explain">姓名需先用GBK编码后再MD5加密转大写</span>
                    </div>
                    <div class="requestCodeList">
                        <span class="name">result</span>
                        <span class="required"></span>
                        <span class="type">string</span>
                        <span class="explain">身份证号码MD5大写</span>
                    </div>
                    <div class="requestCodeList">
                        <span class="name">result.res</span>
                        <span class="required"></span>
                        <span class="type">string</span>
                        <span class="explain">身份证号码MD5大写</span>
                    </div>
                </div>
            </div>
        </div>
        <!--JSON返回示例-->
        <div class="jsonWrap">
            <div class="jsonBox">
                <div class="jsonBoxTitle">JSON返回示例：</div>
                <pre class="json">
<code>
"reason": "成功 ",
    "result": {
    "res": 2,
    "resmsg": "手机号和证件号不一致,姓名不一致",
    "rtype": "01",
    "orderid": "J20180629094946844Q7"
    },
    "error_code": 0
}
</code>
                </pre>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "faceApiDocument",
        mounted() {
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();
        },
        methods: {
            scrollFun() {
                this.$animate(document.getElementsByClassName("addressWrap")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("requestWrap")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("responseWrap")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("jsonWrap")[0], "fadeInUp");
            },
            apiBtnEvent() {
                this.eventBus.$emit("FapiClick", true);
            }
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
        }
    }
</script>

<style lang="scss" scoped>
    #apiDocument {
        .addressWrap {
            background: #fff;

            .address {
                width: 1200px;
                margin: 0 auto;
                padding: 80px 0;

                div {
                    display: flex;
                    align-items: center;
                    margin-bottom: 14px;
                    font-size: 16px;
                    color: #152346;
                    line-height: 28px;

                    span {
                        display: inline-block;
                        font-weight: 600;
                        margin-right: 3px;
                    }
                }

                button {
                    width: 166px;
                    height: 60px;
                    line-height: 60px;
                    border-radius: 30px;
                    font-size: 16px;
                    text-align: center;
                    color: #FFFFFF;
                    background: #2424F0;
                    cursor: pointer;
                }
            }
        }

        .requestWrap {
            background: rgba(0, 15, 13, 0.05);

            .parameter {
                padding: 66px 0 55px;
            }
        }

        .responseWrap {
            background: #fff;

            .parameter {
                padding: 80px 0 76px;
            }
        }

        .requestWrap, .responseWrap {
            .parameter {
                width: 1200px;
                margin: 0 auto;

                .requestTitle {
                    margin-bottom: 30px;
                    font-size: 16px;
                    font-weight: 600;
                    color: #152346;
                }

                .requestCodeWrap {
                    .requestCodeList {
                        display: flex;
                        align-items: center;
                        padding-bottom: 12px;
                        margin-bottom: 12px;
                        border-bottom: 1px solid rgba(0, 0, 0, 0.05);

                        &:last-child {
                            border-bottom: none;
                        }

                        span {
                            font-size: 16px;
                            color: #152346;
                        }

                        .name, .type {
                            min-width: 119px;
                        }

                        .required {
                            min-width: 105px;
                        }
                    }
                }
            }
        }

        .jsonWrap {
            background: rgba(0, 15, 13, 0.05);

            .jsonBox {
                width: 1200px;
                margin: 0 auto;
                padding: 66px 0;

                .jsonBoxTitle {
                    margin-bottom: 30px;
                    font-weight: 600;
                    font-size: 16px;
                    color: #152346;
                }

                .json {
                    width: 100%;
                    padding: 20px;
                    border-radius: 5px;
                    border: 1px solid #D5D9DF;
                    background: #FFFFFF;
                }
            }
        }
    }
</style>